import Radium from "radium";
import React, { Component } from "react";
import { httpGet, httpPost, httpPut } from "../../Util/http";
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import { semanticColors } from "../../Globals/styles";
import { setNavHeader } from "../../MainClient/Navbar/actions";

class Client extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: {},
      errors: {},
    };
  }

  componentDidMount() {
    this.props.dispatch(setNavHeader(true, "Bygherre"))
    const { id } = this.props.params;
    if (id === "create-new") {
      this.setState({
        create: true,
      });
    } else {
      httpGet(process.env.REACT_APP_webApiEndPoint + `api/client/${id}`)
        .then((res) => res.json())
        .then((resp) => {
          console.log("john", resp);
          this.setState({ client: resp });
        });
    }
  }

  validate() {
    const { name } = this.state.client;
    console.log("fra her", this.state);
    const errors = {};
    if (!name || name.length === 1) {
      errors["name"] = "Indtast gyldig navn";
    }
    this.setState({
      errors,
    });
    return Object.keys(errors).length === 0;
  }

  submit() {
    if (!this.validate()) return;
    const { id } = this.props.params;

    if (this.state.create) {
      console.log("create");
      const { name, number, contacts } = this.state.client;
      const url = process.env.REACT_APP_webApiEndPoint + `api/client/createv2`;
      httpPost(url, {
        name,
        number,
        contacts: contacts || []
      }).then((resp) => {
        this.setState({
          message: "Bygherre oprettet",
        });
      }).catch((err) => {
        try {
          const mes = JSON.parse(err.message);
          if (mes.status === 409) {
            alert("Ops! " + mes.statusText);
          } else {
            alert('Noget gik galt!')
          }
        } catch (err) {
          alert("noget gik galt!");
        }
      });
    } else {
      console.log("edit");
      const { name, archived, contacts } = this.state.client;
      const url = process.env.REACT_APP_webApiEndPoint + `api/client/${id}`;
      httpPut(url, {
        name,
        archived,
        contacts: contacts || []
      })
        .then((resp) => {
          this.setState({
            message: "Bygherre opdateret",
          });
        })
        .catch((err) => {
          try {
            const mes = JSON.parse(err.message);
            if (mes.status === 409) {
              alert("Ops! " + mes.statusText);
            }
            if (mes.status === 404) {
              alert("Hov kontakt support! " + mes.statusText);
            }
            alert("Noget gik galt")
          } catch (err) {
            alert("noget gik galt!");
          }
        });
    }
  }

  render() {
    return (
      <div style={styles.container} className="flex-gap">
        <form
          onSubmit={(evt) => {
            evt.preventDefault();
            this.submit();
          }}
          style={styles.form}
        >
          <div style={styles.inputWrapper}>
            <label>Navn</label>
            <input
              value={this.state.client.name}
              onChange={(evt) =>
                this.setState({
                  client: { ...this.state.client, name: evt.target.value },
                })
              }
            />
            {this.state.errors["name"] ? (
              <span className="text-danger">{this.state.errors["name"]}</span>
            ) : null}
          </div>
          <div style={styles.inputWrapper}>
            <label>Kontaktpersoner</label>

            {(this.state.client.contacts || []).map((contact, idx) => {
              return (
                <div key={idx} style={styles.inputWrapper}>
                  <div style={{ display: 'flex', flexDirection: 'row', }}>
                    <input
                      onChange={(evt) => {
                        const value = evt.target.value;
                        const contacts = [...this.state.client.contacts || []]
                        contacts[idx].name = value;
                        this.setState({
                          ...this.state.client,
                          contacts
                        })
                      }}
                      value={contact.name}
                    />
                    {!contact.id || this.state.create ? null :
                      <button onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        const contacts = [...this.state.client.contacts || []]
                        contacts[idx].archived = !contact.archived;
                        this.setState({
                          ...this.state.client,
                          contacts
                        })
                      }}
                        style={{ marginLeft: 6 }} className={`btn ${contact.archived === true ? "btn-danger" : 'btn-default'}`}
                      >
                        {contact.archived === true ? "Arkiveret" : 'Arkiver'}
                      </button>
                    }

                  </div>
                </div>)
            })
            }
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginTop: 6 }}>
              <button className="btn btn-default" onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                const contacts = [...this.state.client.contacts || [], { name: "" }]
                this.setState({
                  client: {
                    ...this.state.client,
                    contacts
                  }
                })
              }}>
                Tilføj
              </button>
            </div>

          </div>

          <div>
            <label style={{ color: semanticColors.danger }}>Arkiveret</label>
            <input
              type="checkbox"
              style={{ boxShadow: "none", width: 25, height: 14 }}
              checked={this.state.client.archived}
              onChange={(evt) =>
                this.setState({
                  client: {
                    ...this.state.client,
                    archived: evt.target.checked,
                  },
                })
              }
            />
          </div>
          <div style={styles.buttonsContainer}>
            <div></div>
            <div style={{ width: 150 }}>
              <span
                style={{
                  fontWeight: "bold",
                  color: semanticColors.success,
                }}
              >
                {this.state.message}
              </span>
            </div>
            <button type="submit" className="btn btn-primary">
              {this.state.create ? "Opret" : "Opdater"}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: semanticColors.default,
    height: "100%",
    marginTop: 40,
    padding: 40,
  },
  form: {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: 12,
    maxWidth: 720,
  },
  inputWrapper: {
    width: "100%",
    marginBottom: 6
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
  },
  buttons: {
    margin: 6,
  },
};
export default connect()(Radium(withRouter(Client)));



// WEBPACK FOOTER //
// ./src/App/Clients/Client/index.jsx